// Sourced directly from the Java enums you shared.

export const TRIGGER_DATE_OPTIONS = ["OnDATE", "DateBEFORE", "DateAFTER"];

export const LAUNCH_TEMPLATE_VERSION_TYPES = ["NEW", "UPDATED"];

export const TO_EMAIL_SOURCE_FROM_OPTIONS = [
  "CANDIDATE",
  "DEPARTMENT",
  "BRANCH",
  "ROLE",
  "ALLEMP",
  "SPECIFIC_EMPLOYEES",
  "COMPANY",
  "RESPECTIVE_EMPLOYEE",
  "RESPECTIVE_MANAGER",
  "RESPECTIVE_HR",
  "RESPECTIVE_ACCOUNTANT",
  // RTM
  "AUTHORITY",
  "RESPECTIVE_HOD",
  "RESPECTIVE_INTERVIEWER",
  "RESPECTIVE_RECRUITER_HR",
  "RESPECTIVE_CONSULTANT",
  "RESPECTIVE_INTERVIEWERS",
  "RESPECTIVE_VACANCY_CREATOR",
  "ALL_RESPECTIVE_NEXT_ROUND_INTERVIEWERS",
  // PMT
  "ALL_MEMBERS_IN_PROJECT",
  "RESPECTIVE_TASK_ASSIGNED_MEMBERS",
  "RESPECTIVE_STAGE_TASK_ASSIGNED_MEMBERS",
  "RESPECTIVE_PROJECT_MEMBER",
  // CRM-admin
  "RESPECTIVE_OPERATION_STAGE_MEMBERS",
  "RESPECTIVE_CLIENT_ASSIGNED_EMPLOYEE",
  "RESPECTIVE_LEAD_ASSIGNED_EMPLOYEE",
];

export const FROM_EMAIL_SOURCE_OPTIONS = [
  "CANDIDATE",
  "SPECIFIC",
  "COMPANY",
  "RESPECTIVE_EMPLOYEE",
  "RESPECTIVE_MANAGER",
  "RESPECTIVE_HR",
  "RESPECTIVE_ACCOUNTANT",
  // recruiter
  "RESPECTIVE_HOD",
  "RESPECTIVE_RECRUITER_HR",
  "TOOL",
  "RESPECTIVE_INTERVIEWER",
  // crm
  "RESPECTIVE_PRODUCTION_MANAGER",
  "RESPECTIVE_SALES_MANAGER",
];

// --- Not covered by an enum you sent me — best guess from the Swagger example
// values, please confirm/replace with your real enum values. ---

// Guessed from the "status": "ENABLED" example on both request/response bodies.
export const AUTOMATION_STATUS_OPTIONS = ["ENABLED", "DISABLED"];

// Guessed from the "templateStatus": "CUSTOM" example.
export const TEMPLATE_STATUS_OPTIONS = ["DEFAULT", "CUSTOM"];

// Guessed from the "notification.status" / "automation.status": "PENDING" example.
export const LAUNCH_STATUS_OPTIONS = ["PENDING", "LAUNCHED"];

// Confirmed enum (LaunchTemplateStatus, backend):
export const LAUNCH_TEMPLATE_STATUS_OPTIONS = [
  "PENDING",
  "LAUNCHED",
  "UPDATING",
  "ON_HOLD",
];

// The /admin/scheduled-events/notifications/status (and, presumably,
// /admin/scheduled-cron-jobs/automations/status) endpoint only lets you set
// a notification/automation to one of these two values.
export const NOTIFICATION_ACTION_STATUS_OPTIONS = ["LAUNCHED", "ON_HOLD"];
